<template>
  <div id="app">
    <div class="indio_loader" :style="{ display: isLoaded ? 'none' : 'block' }">
      <div class="indio_loader_container">
        <div class="indio_loader_spinner"></div>
      </div>
    </div>
    <transition-group name="slide-fade">
      <template v-if="getAgeGateToken || $router.currentRoute.params.id === 'politics' || $router.currentRoute.params.id === 'cookies' || $router.currentRoute.params.id === 'tycos'">
        <router-view v-if="$router.currentRoute.params.id === 'sustentable'" name="sustentable" key="sustentable"></router-view>
        <router-view v-else-if="$router.currentRoute.params.id === 'tienditascolormexico'" name="tienditascolormexico" key="tienditascolormexico"></router-view>
        <router-view v-else-if="$router.currentRoute.params.id === 'labandaincontenible'" name="labandaincontenible" key="labandaincontenible"></router-view>
        <router-view v-else-if="$router.currentRoute.params.id === 'politics'" name="politics" key="politics"></router-view>
        <router-view v-else-if="$router.currentRoute.params.id === 'cookies'" name="cookies" key="cookies"></router-view>
        <router-view v-else-if="$router.currentRoute.params.id === 'tycos'" name="tycos" key="tycos"></router-view>
        <router-view v-else key="indio"></router-view>
        <!-- <BannerCookies key="bannercookies" /> -->
        <!--<ModalPopup
          v-if="showModal && !($router.currentRoute.params.id==='sustentable') && !($router.currentRoute.params.id==='tienditascolormexico') && !($router.currentRoute.params.id==='labandaincontenible')"
          v-bind:wichModal="wichModal"
          @close="showModal = false"
          key="popup"
        />-->
      </template>
    </transition-group>
    <transition-group name="slide-fade">
      <template v-if="!getAgeGateToken && $router.currentRoute.params.id !== 'politics' && $router.currentRoute.params.id !== 'cookies' && $router.currentRoute.params.id !== 'tycos'">
        <AgeGate v-if="$router.currentRoute.params.id != 'politics'" key="agegate" />
        <!-- <BannerCookies v-if="$router.currentRoute.params.id != 'politics'" key="bannercookies" /> -->
        <router-view v-if="$router.currentRoute.params.id === 'politics'" name="politics" key="politics"></router-view>
        <router-view v-if="$router.currentRoute.params.id === 'cookies'" name="cookies" key="cookies"></router-view>
        <router-view v-if="$router.currentRoute.params.id === 'tycos'" name="tycos" key="tycos"></router-view>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import AgeGate from "@/containers/AgeGatem";
import BannerCookies from "@/components/BannerCookies";
//import ModalPopup from "../src/components/ModalPopup"

export default {
  name: "app",
  components: {
    AgeGate,
    BannerCookies,
    //ModalPopup,
  },
  data() {
    return {
      toggler: false,
      // showModal: false,
      // wichModal: "terms",
    };
  },
  computed: {
    ...mapGetters(["getAgeGateToken", "isLoaded"]),
  },
  methods: {
    ...mapActions({
      setScrollMotionAction: "setScrollMotion",
      setEdgeScrollingAction: "setEdgeScrolling",
      resetEdgeScrollingAction: "resetEdgeScrolling",
      setLoadStatus: "setLoadStatus",
      setAgeGateTokenAction: "setAgeGateToken",
    }),
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        this.setScrollMotionAction("downEnd");
      } else if (scrollTop + clientHeight <= clientHeight + 5) {
        this.setScrollMotionAction("upStart");
      } else {
        this.setScrollMotionAction("scrolling");
      }
    },
    // popUpModal(modalType) {
    //   this.showModal = true;
    //   this.wichModal = modalType;
    // },
    localStorageInclude(value) {
      let include  = false;
      for (let i = 0; i < localStorage.length; i++) {
        let key = localStorage.key(i);
        let _value = localStorage.getItem(key);
        if(_value === value){
          include = true
        }
      }
      return include
    },
    /*loadScripts() {
      const script1 = document.createElement('script');
      script1.src = "https://cdn-ukwest.onetrust.com/consent/bfaf1536-19b4-44b6-bbe2-b73f3915366a/OtAutoBlock.js";
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.src = "https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js";
      script2.setAttribute('data-document-language', 'true');
      script2.setAttribute('type', 'text/javascript');
      script2.setAttribute('charset', 'UTF-8');
      script2.setAttribute('data-domain-script', 'bfaf1536-19b4-44b6-bbe2-b73f3915366a');
      document.head.appendChild(script2);

      const script3 = document.createElement('script');
      script3.textContent = "function OptanonWrapper() { }";
      document.head.appendChild(script3);
    }*/
    loadScripts() {
      const script1 = document.createElement('script');
      script1.src = "https://cdn.cookielaw.org/consent/0191467b-3ac5-7a5e-a1f9-d0973337f1e8/OtAutoBlock.js";
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
      script2.setAttribute('data-document-language', 'true');
      script2.setAttribute('type', 'text/javascript');
      script2.setAttribute('charset', 'UTF-8');
      script2.setAttribute('data-domain-script', '0191467b-3ac5-7a5e-a1f9-d0973337f1e8');
      document.head.appendChild(script2);

      const script3 = document.createElement('script');
      script3.textContent = "function OptanonWrapper() { }";
      document.head.appendChild(script3);
    }
  },
  mounted() {
    const cookies = document.cookie;
    const OneTrustStorage = this.localStorageInclude('fc482041bb2d2f4b43ee11e07982dabd0c7de2aae21d3df7a093009908878b32');
    const OneTrustCookie = cookies.includes('fc482041bb2d2f4b43ee11e07982dabd0c7de2aae21d3df7a093009908878b32');
    if (OneTrustCookie || OneTrustStorage) {
      this.setAgeGateTokenAction(true);
    }
    // window.onload = () => {
    //   this.setLoadStatus()
    // }
    document.addEventListener("readystatechange", (event) => {
      this.setLoadStatus()
    });
    this.$nextTick(() => { });
    const query = this.$route.query;
    localStorage.setItem('query', JSON.stringify(query));
    // this.popUpModal('popup');

    this.loadScripts();
  },
};
</script>

<style lang="scss">
@import "./styles/main.scss";

.indio_loader {
  background: linear-gradient(180deg,
  $green-pantone-7729c 0,
  $light-green-pantone-3288c 100%);
  position: fixed;
  top: 0;
  left: 0;
  display: block;
  height: 100%;
  height: 100vh;
  width: 100%;
  width: 100vw;
  overflow: hidden;
  z-index: 100000000000;

  .indio_loader_container {
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;

    .indio_loader_spinner {
      border: 8px solid transparent;
      border-top: 8px solid #90ca65;
      border-bottom: 8px solid #90ca65;
      border-radius: 50%;
      width: 120px;
      height: 120px;
      animation: spin 2s linear infinite;
    }
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
